export var ADD_VERSION_REQUEST = 'app/VersionNew/ADD_VERSION_REQUEST';
export var ADD_VERSION_SUCCESS = 'app/VersionNew/ADD_VERSION_SUCCESS';
export var ADD_VERSION_FAILURE = 'app/VersionNew/ADD_VERSION_FAILURE';
export var GET_CHANGELOG_REQUEST = 'app/VersionNew/GET_CHANGELOG_REQUEST';
export var GET_CHANGELOG_SUCCESS = 'app/VersionNew/GET_CHANGELOG_SUCCESS';
export var GET_CHANGELOG_FAILURE = 'app/VersionNew/GET_CHANGELOG_FAILURE';
export var GET_VERSION_DETAILS_REQUEST = 'app/VersionNew/GET_VERSION_DETAILS_REQUEST';
export var GET_VERSION_DETAILS_SUCCESS = 'app/VersionNew/GET_VERSION_DETAILS_SUCCESS';
export var GET_VERSION_DETAILS_FAILURE = 'app/VersionNew/GET_VERSION_DETAILS_FAILURE';
